import { useQueryCashed } from "@/hooks/useQueryCashed";

import { SearchInputsApi, SearchLadiesApi } from "../api";
import { LadiesSearchReqParams } from "../helpers/convertFormValuesToParams";

export const useLadiesSearch = (_params: LadiesSearchReqParams | null) => {
  return useQueryCashed({
    queryKey: ["LADIES_SEARCH", { _params }],
    queryFn: async () => {
      return SearchLadiesApi.get(_params || {});
    },
  });
};

export const useLadiesSearchPaginationOptions = (
  _params: LadiesSearchReqParams | null,
) => {
  return useQueryCashed({
    queryKey: ["SEARCH_PAGINATION_OPTIONS", { _params }],
    queryFn: async () => {
      return SearchLadiesApi.getPaginationOptions(_params || {});
    },
  });
};

export const useSearchSelectCountries = () => {
  return useQueryCashed({
    queryKey: ["SEARCH_INPUT_COUNTRY"],
    queryFn: () => {
      return SearchInputsApi.getCountries();
    },
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};

export const useSearchInputsOptions = () => {
  return useQueryCashed({
    queryKey: ["SEARCH_INPUTS_OPTIONS"],
    queryFn: () => {
      return SearchInputsApi.getInputsOptions();
    },
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};

export const useCitiesByCountry = (countryId?: string) => {
  return useQueryCashed({
    queryKey: ["SEARCH_CITY_OPTIONS", { countryId }],
    queryFn: () => {
      return SearchInputsApi.getCitiesByCountry(countryId as string);
    },
    enabled: !!countryId,
  });
};
